<template>
  <div v-if="!isLoading && missingFiles.length" class="ws-group-missing-files">
    <b-tooltip :label="tooltipLabel" position="is-bottom" :type="'is-danger'">
      <ws-dot-status type="danger" />
    </b-tooltip>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { ARRAY_FILE } from './modals/const/index.ts'

export default {
  name: 'WsGroupMissingFiles',
  props: {
    guid: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loadedFiles: {},
      isLoading: false
    }
  },
  computed: {
    requiredFiles () {
      return ARRAY_FILE.filter(file => file.required)
    },
    missingFiles () {
      return this.requiredFiles.filter(file => {
        return !this.loadedFiles[file.name] || this.loadedFiles[file.name].length === 0
      })
    },
    tooltipLabel () {
      if (!this.missingFiles.length) {
        return ''
      }
      const fileNames = this.missingFiles.map(file => `«${file.shortLabel}»`).join(', ')
      return `${fileNames} не загружены`
    }
  },
  methods: {
    ...mapActions('profile/files', {
      getFileByRecId: 'getFileByRecId'
    }),
    async fetchFiles () {
      if (this.isLoading) return
      this.isLoading = true
      const filePromises = this.requiredFiles.map(file => this.fetchFile(file.name))
      await Promise.all(filePromises)
      this.isLoading = false
    },
    async fetchFile (category) {
      try {
        const files = await this.getFileByRecId({
          'rec-guid': this.guid,
          category
        })
        this.$set(this.loadedFiles, category, files)
      } catch (error) {
        console.error(`Error fetching files for category ${category}:`, error)
        this.$set(this.loadedFiles, category, [])
      }
    }
  },
  watch: {
    guid: {
      handler: 'fetchFiles',
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
.ws-group-missing-files {
  display: inline-block;
  margin-left: 8px;
  vertical-align: middle;
}
</style>
